import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'capitalizeAll',
  standalone: true
})
export class CapitalizeAllPipe implements PipeTransform {

  transform(value: string): string {
    if (typeof value !== 'string') return "";

    return value
      .split(' ')
      .map(val => val.toLowerCase())
      .map(val => val.charAt(0).toUpperCase() + val.slice(1))
      .join(' ');
  }

}
